module.exports = __webpack_public_path__ + "static/media/double-standard-img8.8f87fa9d.jpg";